// extracted by mini-css-extract-plugin
module.exports = {"changePasswordConfirmation":"ChangePasswordConfirmation_changePasswordConfirmation__33VmB"};